import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Card } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import '../Turnero.css';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faTrash } from '@fortawesome/free-solid-svg-icons';

/**
 * ScreenParams - Multimedia Configuration (URLs)
 */
const ScreenParams = ({ ipserv, hideHeader = false, branch_id }) => {
    const [loading, setLoading] = useState(false);
    const [types, setTypes] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [params, setParams] = useState([]); // List of {ParamId, UrlMultimedia, MultimediaTipo, Orden}
    const [newParam, setNewParam] = useState({
        MultimediaTipo: 'IMAGE',
        Orden: 0
    });
    const [subStatus, setSubStatus] = useState(null);

    const loadTypes = () => {
        if (!branch_id) return;
        setLoading(true);
        request.Get(ipserv + 'getTurneroTipos', { sucursalId: branch_id }, r => {
            if (r.success) {
                setTypes(r.rows || []);
                if (r.rows?.length > 0 && !selectedType) setSelectedType(r.rows[0]);
            }
            setLoading(false);
        });
    };

    const loadParams = (typeId) => {
        if (!typeId || !branch_id) return;
        setLoading(true);
        request.Get(ipserv + 'getTurneroParams', { typeId, sucursalId: branch_id }, r => {
            if (r.success) setParams(r.data || []);
        });
        setLoading(false);
    };

    const loadSubscription = () => {
        request.Get(ipserv + 'turnero/subscription-status', {}, r => {
            if (r.success) setSubStatus(r);
        });
    };

    useEffect(() => {
        loadTypes();
        loadSubscription();
    }, [branch_id]);

    useEffect(() => {
        if (selectedType) loadParams(selectedType.TipoId);
    }, [selectedType]);

    const handleAddParam = (e) => {
        e.preventDefault();
        if (!selectedType || !branch_id) return;

        if (newParam.MultimediaTipo === 'VIDEO' && subStatus && !subStatus.plan.AllowVideo) {
            Notify({ type: 'info', text: 'Tu plan actual no permite el uso de videos. Actualiza a Premium para habilitar esta función.' });
            return;
        }

        setLoading(true);
        request.Post(ipserv + 'saveTurneroParams', { ...newParam, TipoId: selectedType.TipoId, SucursalId: branch_id }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Parámetro agregado' });
                setNewParam({ UrlMultimedia: '', MultimediaTipo: 'IMAGE', Orden: params.length + 1 });
                loadParams(selectedType.TipoId);
            } else {
                Notify({ type: 'fail', text: r.message || 'Error al agregar' });
            }
            setLoading(false);
        });
    };

    const handleDeleteParam = (id) => {
        // Implement delete logic calling backend
    };

    return (
        <div className={`turnero-container ${hideHeader ? 'p-0' : 'p-4'}`}>
            {!hideHeader && <h2 className="turnero-title">Parametría de Pantallas</h2>}

            <Row>
                <Col md={3}>
                    <div className="turnero-card p-3 mb-3">
                        <h5 className="text-muted small mb-3">Seleccionar Tipo</h5>
                        <ul className="list-unstyled">
                            {types.map(t => (
                                <li
                                    key={t.TipoId}
                                    className={`p-2 mb-2 rounded cursor-pointer transition-all ${selectedType?.TipoId === t.TipoId ? 'bg-primary text-white' : 'text-muted hover-bg-glass'}`}
                                    onClick={() => setSelectedType(t)}
                                >
                                    {t.TipoNombre} ({t.TipoAcronimo})
                                </li>
                            ))}
                        </ul>
                    </div>
                </Col>

                <Col md={9}>
                    <div className="turnero-card p-4 mb-4">
                        <h5 className="mb-3">Agregar Multimedia para {selectedType?.TipoNombre}</h5>
                        <form onSubmit={handleAddParam}>
                            <Row>
                                <Col md={6}>
                                    <input
                                        type="url"
                                        className="turnero-input"
                                        placeholder="URL de Imagen o Video"
                                        value={newParam.UrlMultimedia}
                                        onChange={e => setNewParam({ ...newParam, UrlMultimedia: e.target.value })}
                                        required
                                    />
                                </Col>
                                <Col md={3}>
                                    <select
                                        className="turnero-input"
                                        value={newParam.MultimediaTipo}
                                        onChange={e => setNewParam({ ...newParam, MultimediaTipo: e.target.value })}
                                    >
                                        <option value="IMAGE">Imagen</option>
                                        <option value="VIDEO">Video</option>
                                    </select>
                                </Col>
                                <Col md={3}>
                                    <button type="submit" className="turnero-btn turnero-btn-primary w-100" disabled={loading}>
                                        Agregar
                                    </button>
                                </Col>
                            </Row>
                        </form>
                    </div>

                    <h5 className="mb-3">Contenido Actual</h5>
                    <Row>
                        {loading && params.length === 0 ? (
                            <Col className="text-center p-5"><Spinner animation="border" /></Col>
                        ) : params.length === 0 ? (
                            <Col className="text-muted text-center p-5">No hay multimedia configurada</Col>
                        ) : (
                            params.map((p, idx) => (
                                <Col md={4} key={p.ParamId} className="mb-3 animate-in" style={{ animationDelay: `${idx * 0.1}s` }}>
                                    <div className="turnero-card overflow-hidden">
                                        <div className="aspect-ratio-box" style={{ height: '150px', background: '#000' }}>
                                            {p.MultimediaTipo === 'IMAGE' ? (
                                                <img src={p.UrlMultimedia} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center h-100">
                                                    <FontAwesomeIcon icon={faVideo} size="2x" className="text-muted" />
                                                </div>
                                            )}
                                        </div>
                                        <div className="p-2 d-flex justify-content-between align-items-center">
                                            <span className="small text-muted text-truncate">{p.UrlMultimedia}</span>
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteParam(p.ParamId)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        )}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default ScreenParams;
